// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27wkV","input":"styles_input__1yxBA"};